import "./Videos.module.css";
import Header from "@/reusable_sections/Header";
import VideosHero from "./sections/VideosHero";
import VideoGallery from "./sections/VideoGallery";
import ContactCta from "./sections/ContactCta";
import Footer from "@/reusable_sections/Footer";
export default function VideosPage() {
  return <div>
      <Header />
      <VideosHero />
      <VideoGallery />
      <ContactCta />
      <Footer />
    </div>;
}